import { BaseNodeModel } from "@/models/nodes/BaseNodeModel";
import { InlineNodeModel } from "@/models/nodes/InlineNodeModel";

import type { DocumentModel } from "@/models/DocumentModel";
import type { NodeModel, NodeId } from "@/models/nodes/types";
import type { VisitableNode, NodeVisitor } from "@/models/nodes/visitors/NodeVisitor";
import type {
  GraphExpressionNodeProps,
  GraphExpressionNodeConstructorProps,
  Color,
} from "@corca/data";

export class GraphExpressionNodeModel
  extends BaseNodeModel<GraphExpressionNodeProps>
  implements VisitableNode
{
  static type = "graphExpression" as const;

  type = GraphExpressionNodeModel.type;

  protected fillRequiredProps(
    props: GraphExpressionNodeConstructorProps,
  ): GraphExpressionNodeProps {
    return props;
  }

  static create(
    doc: DocumentModel,
    props: GraphExpressionNodeConstructorProps = {},
    nodes: NodeModel[] = [],
    id?: NodeId,
  ) {
    return new GraphExpressionNodeModel(doc, id, props, nodes);
  }

  get inlineNode(): InlineNodeModel | undefined {
    return this.nodes.find((n) => n.is(InlineNodeModel));
  }

  get color(): Color | undefined {
    return this.props.color;
  }

  set color(value: Color) {
    this.updateProps({ color: value });
  }

  accept<R>(visitor: NodeVisitor<R>): R {
    return visitor.visitGraphExpressionNode(this);
  }
}
